import {Field, Formik} from "formik";
import Blocks from "../blocks";
import Fields from "../formFields";
import UTILS from '../../utils';
import {createTeacher} from "../../api/user";
import {useMutation} from "react-query";
import Partials from "../partials";
import SignupBg from "../../assets/images/study-signup.svg";
import { IoMdArrowBack } from "react-icons/io";
import {useHistory} from "react-router-dom";
import {useState} from "react";

const PageTeacherSignup = () => {
    const history = useHistory();
    const initialValues = {
        email: '',
        password: '',
        first_name: '',
        last_name: '',
        mobile_number: '',
        passwordConfirmation: '',
        countryDial: '',
        countryCode: "IN",
    }
    const [fields, updateFields] = useState({password: true, passwordConfirmation: true});

    const {isLoading, error, isError, mutate, data} = useMutation(createTeacher, {
        onSuccess: (data) => {
            const email = data?.data.body?.email;
            history.push(`/verify/${email}`);
        },
        onError: (err) => {
            console.log(err);
        },
    });

    const toggle = (inputName) => {
        updateFields({
            ...fields,
            [inputName]: !fields[inputName]
        })
    }

    const signUpSubmit = async (values, action) => {

        const {passwordConfirmation, email, first_name, last_name, password,} = values;
        const mobileNo = `+${values.countryDial}-${values.mobile_number.slice(values.countryDial.length)}`;

        const formResponse = {
            passwordConfirmation,
            email,
            first_name,
            last_name,
            password,
            mobile_number: mobileNo
        }
        mutate(formResponse);
    }

    return (
        <div className={'page PageTeacherSignup'}>
            <div className="container mx-auto">
                {/* <h3 className={"block md:hidden text-xl text-center pt-16 pb-4 font-['Poppins-Bold']"}>{'Let\'s create your teacher account'}</h3> */}
                <div className="mt-16 md:hidden flex items-center gap-2 justify-center px-4">
                <IoMdArrowBack size={20} onClick={() => history.push("/login")} className="cursor-pointer" />
                <h3 className="text-xl font-bold">Let&apos;s create your teacher account</h3>
                </div>
                <div className="flex flex-col md:flex-row items-center">
                    <div className="bgWrapper md:flex justify-center items-center bg-white">
                        <img src={SignupBg} alt="" draggable={false}/>
                    </div>
                    <div
                        className="pageContent w-full max-w-lg mx-auto md:mr-0 md:ml-auto mt-4 md:mt-0  mb-4 bg-white p-4 rounded-xl">
                        {error && <h3 className="text-red-600 my-2">{error?.response?.data?.message}</h3>}
                        {/* <h4 className={'hidden md:block text-2xl font-subheading'}>{'Let\'s create your teacher account'}</h4> */}
                        <div className="hidden md:flex items-center gap-2 mb-2">
                        <IoMdArrowBack size={30} onClick={() => history.push("/login")} className="cursor-pointer" />
                       <h4 className="text-2xl font-subheading">Let&apos;s create your teacher account</h4>
                        </div>

                        <Blocks.ErrorBoundary>
                            <Formik
                                initialValues={initialValues}
                                validationSchema={UTILS.forms.SignUpSchema}
                                onSubmit={signUpSubmit}
                            >
                                {({
                                      handleSubmit,
                                      isSubmitting,
                                  }) => (
                                    <form onSubmit={handleSubmit} className="pt-6 pb-8">
                                        <div className="md:grid md:grid-cols-2 gap-4">
                                            <Field type={'text'} name="first_name" placeholder="First Name"
                                                   iconBefore={<i className={`text-xl icon icon-user`}></i>}
                                                   component={Fields.FieldInput}/>
                                            <Field type='text' name="last_name" placeholder="Last Name"
                                                   iconBefore={<i className={`text-xl icon icon-user`}></i>}
                                                   component={Fields.FieldInput}/>
                                        </div>

                                        <Field type='email' name="email" placeholder="Email Id"
                                               iconBefore={<i className={`text-xl icon icon-mail1`}></i>}
                                               component={Fields.FieldInput}/>
                                        <Field type='text' name="mobile_number" placeholder="Mobile number"
                                               iconBefore={<i className={`text-xl icon icon-phone`}></i>}
                                               component={Fields.FieldInputPhoneNumber}/>
                                        <Field type={fields.password ? 'password' : 'text'} name="password"
                                               placeholder="Password"
                                               iconBefore={<i className={`text-xl icon icon-unlock`}></i>}
                                               iconAfter={
                                                   <i className={`text-xl icon icon-${fields.password ? 'eye-off' : 'eye'}`}
                                                      onClick={() => toggle('password')}></i>}
                                               component={Fields.FieldInput}/>
                                        <Field type={fields.passwordConfirmation ? 'password' : 'text'}
                                               name="passwordConfirmation" placeholder="Re-type Password"
                                               iconBefore={<i className={`text-xl icon icon-unlock`}></i>}
                                               iconAfter={
                                                   <i className={`text-xl icon icon-${fields.passwordConfirmation ? 'eye-off' : 'eye'}`}
                                                      onClick={() => toggle('passwordConfirmation')}></i>}
                                               component={Fields.FieldInput}/>
                                        <button
                                            disabled={isLoading}
                                            className="bg-black w-full hover:bg-zinc-700 text-white inline-flex justify-center font-bold py-3 px-4 rounded focus:outline-none focus:shadow-outline transition ease-in-out duration-150"
                                            type="submit">
                                            {isLoading &&
                                                <Partials.PartialLoading/>
                                            }
                                            Submit
                                        </button>
                                    </form>
                                )}
                            </Formik>
                        </Blocks.ErrorBoundary>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PageTeacherSignup
